import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Relaxation13 = () => {
  return (
    <section className="flex mt-[30px] gap-6 px-5 mb-[40px] text-[#2A5801]">
      {/* relaxation */}
      <div className="bg-white w-full px-4 shadow-lg rounded-[10px]">
        <div className="inline-block mx-[10px] px-[5px] rounded-[5px] mt-[10px]">
          <h2 className="text-xl font-bold">RELAXATION</h2>
          <h5 className="mt-[5px] text-[#2A5801] font-bold">INSTRUCTIONS</h5>
          <p className="text-[#2A5801]">
            Focus on your breath for 1 minutes, inhaling deeply and exhaling
            slowly. Let go of distractions and center your mind.
          </p>
        </div>
        <div className="pt-20 w-full text-center">
          <div className="bg-white shadow-lg rounded-[10px] border border-[#295700]  w-[80%] mx-auto flex justify-center mb-[50px] py-16">
            <img
              className
              src="https://res.cloudinary.com/dvcxb5tpj/image/upload/v1700691587/undraw_Meditating_re_aiqa_1_qsx6n0.svg"
            />
          </div>
          <Link to="/">
            <button className="bg-[#295700] rounded-[5px] px-14 py-1.5 text-white w-2/5 mb-[15px]">
              Get Started
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Relaxation13;
